import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../../firebase'; // ✅ Adjust if needed
import QuestionRenderer from './QuestionRenderer';

const ListeningQuestions = ({ jsonPath }) => {
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const { passageId, mockId } = useParams(); // useParams() from route
  const navigate = useNavigate();
  const user = auth.currentUser;

  useEffect(() => {
    const loadData = async () => {
      const res = await fetch(jsonPath);
      const data = await res.json();
      setQuestions(data.questions);
    };
    loadData();
  }, [jsonPath]);

  const handleAnswer = (questionId, value) => {
    const updatedAnswers = { ...answers, [questionId]: value };
    setAnswers(updatedAnswers);
  };

  const isAnswered = (question) => {
    const answer = answers[question.id];
    return question.type === 'multi'
      ? Array.isArray(answer) && answer.length > 0
      : !!answer;
  };

  const handleSubmit = async () => {
    const passageNum = parseInt(passageId);

    // ✅ Save to Firestore
    if (user) {
      const docRef = doc(db, 'users', user.uid, 'mockAnswers', `${mockId}_listening${passageNum}`);
      await setDoc(
        docRef,
        {
          ...answers,
          email: user.email,
          name: user.displayName,
          role: 'student',
          createdAt: serverTimestamp()
        },
        { merge: true }
      );
    }
    

    // ✅ Navigate to next
    if (passageNum < 5) {
      navigate(`/lessonMock/${mockId}/listening/${passageNum + 1}/audio`);
    } else {
      navigate(`/lessonMock/${mockId}/review`);
    }
  };

  return (
    <div className="p-4 max-w-3xl mx-auto">
      <h2 className="text-xl font-bold mb-6">Listening Questions</h2>

      {questions.length === 0 ? (
        <p>Loading...</p>
      ) : (
        questions.map((q, index) => (
          <div key={q.id} className="mb-10 border-b pb-6">
            <h3 className="text-lg font-semibold mb-2">Question {index + 1}</h3>

            {q.audio && (
              <audio controls className="mb-3">
                <source src={q.audio} type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            )}

            <QuestionRenderer
              question={q}
              userAnswer={answers[q.id]}
              onAnswer={(value) => handleAnswer(q.id, value)}
            />
          </div>
        ))
      )}

      <button
        onClick={handleSubmit}
        disabled={questions.some((q) => !isAnswered(q))}
        className="mt-6 px-6 py-2 rounded-md shadow text-white bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400"
      >
        {parseInt(passageId) < 5
          ? `Continue to Passage ${parseInt(passageId) + 1}`
          : 'Submit Listening Section'}
      </button>
    </div>
  );
};

export default ListeningQuestions;
